module.exports = __webpack_public_path__ + "static/OR2s-39c8aa0b31d3b4b87731ab751ef6f3d6.jpg";